import React from 'react';
import styled from 'styled-components';

const Page = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8f9fa;
`;

const Card = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 100%;
`;

const Title = styled.h2`
  margin-bottom: 1rem;
`;

const Message = styled.p`
  color: #555;
  font-size: 1rem;

  a {
    color: #007bff;
    text-decoration: underline;
  }
`;

const ResetExpired = () => {
  return (
    <Page>
      <Card>
        <Title>This Link Has Expired</Title>
        <Message>
          Please return to the <a href="/forgot">Forgot Password</a> page and request a new link.
        </Message>
      </Card>
    </Page>
  );
};

export default ResetExpired;
